import { createFileRoute } from '@tanstack/react-router';
import { TenantManagementSection } from '@/features/admin/components/TenantManagementSection';

export const Route = createFileRoute('/admin/tenants')({
  component: () => <TenantManagementSection />,
});
